import LongRectangleTextButton from 'components/atoms/longRectangleTextButton';
import ProfilePhotoWithoutImage from 'components/atoms/ProfilePhotoWithoutImage';
import {useTheme} from 'contexts/ThemeContext';
import {
  EditProfileScreenProps,
  ProfileScreenProps,
} from 'navigations/ProfileFlow';
import React, {useState} from 'react';
import {View, Text, TouchableOpacity, Image, SectionList} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import strings from '../../translations';
import styleSheet from './styles';
import {useUserStore} from 'contexts/StoreContext';
import imagePicker from 'services/ImagePicker';
import {observer} from 'mobx-react';

const EditProfileScreen = observer((props: EditProfileScreenProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const image = props.route.params.image;
  const name = props.route.params.name;

  const userStore = useUserStore();

  const [imageURI, setImageURI] = useState(image);

  const openPicker = () => {
    imagePicker.pickPhoto().then(result => {
      setImageURI(result);
    });
  };

  const onPressSave = () => {
    userStore.changePhoto(undefined, imageURI);
    props.navigation.pop();
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.imageAndTextContainer}>
        <TouchableOpacity
          style={styles.imageContainer}
          onPress={() => openPicker()}>
          {userStore.user?.image ? (
            <Image source={{uri: imageURI}} style={styles.avatarImage} />
          ) : (
            <ProfilePhotoWithoutImage
              isBigPhoto={true}
              name={userStore.fullUserName}
              isPhotoOnTheHomeGreeting={false}
            />
          )}
          <View style={styles.penContainer}>
            <Image
              source={theme.images.whitePen}
              style={styles.penSize}></Image>
          </View>
        </TouchableOpacity>
        <Text style={styles.textStyle}>{name}</Text>
      </View>
      <LongRectangleTextButton
        title={strings.profile.save}
        onPress={() => onPressSave()}
      />
    </SafeAreaView>
  );
});

export default EditProfileScreen;
